// Utility helpers for game client objects

export function getSuggestedWager(game) {
  const t =
    (game &&
      game.buyTicketMeta &&
      Array.isArray(game.buyTicketMeta.buyArguments) &&
      game.buyTicketMeta.buyArguments[0]) ||
    null;
  return (t && (t.wager || t.minPrice)) || 0;
}

export function formatPrice(game) {
  if (!game) return "0";
  const w = getSuggestedWager(game);
  if (
    game.hasVariablePrice &&
    game.minPrice != null &&
    game.maxPrice != null &&
    game.minPrice !== game.maxPrice
  )
    return `${game.minPrice}-${game.maxPrice}`;
  if (game.minPrice != null) return `${game.minPrice}`;
  return w ? String(w) : "0";
}
